import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/liquidaciones';
import LiquidacionesCrear from './LiquidacionesCrear';

const mstp = state => {
    let cambio_dolar = 0;
    const configuraciones = state.configuracion.configuraciones;
    if (configuraciones.cambio_dolar) {
        cambio_dolar = configuraciones.cambio_dolar.cambio_dolar;
    }
    return { ...state.liquidaciones, cambio_dolar }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(LiquidacionesCrear)
